import { del, get, set } from 'idb-keyval';

const indexedDbChatCacheAdapter = {
  get,
  set,
  remove: del,
};

export default indexedDbChatCacheAdapter;